import { Link } from "react-router-dom";
import AmpleHireInputTag from "../ample-hire-html-tags/ample-hire-input-tag";
import AmpleHireLabelTag from "../ample-hire-html-tags/ample-hire-label-tag";

const RadioButtonInputField = ({
  inputTagCssClasses = "with-gap",
  groupName,
  radioButtonValue,
  value,
  onChange,
  to = "",
  labelText,
  isTooltip,
  tooltipLabel = "",
  toolTipPosition = "top",
  ...props
}) => {
  return (
    <AmpleHireLabelTag isTooltip={isTooltip}>
      <AmpleHireInputTag
        className={inputTagCssClasses}
        name={groupName}
        type={"radio"}
        checked={radioButtonValue === value}
        value={value}
        onChange={onChange}
        {...props}
      />
      {to ? (
        <span>
          <Link className="label-link" to={to}>
            {labelText}
          </Link>
        </span>
      ) : (
        <span>
          {labelText + " "}
          {isTooltip && (
            <i
              className="material-icons dp48 tooltipped"
              data-position={toolTipPosition}
              data-tooltip={tooltipLabel}
            >
              info
            </i>
          )}
        </span>
      )}
    </AmpleHireLabelTag>
  );
};

export default RadioButtonInputField;
